import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from '@americanexpress/one-app-router';
import { connectAsync } from 'iguazu';
import {
  Ensighten,
  Qualtrics,
  ClickToChat,
  Dynatrace,
} from '@americanexpress/shared-scripts';
import { matchLocaleFromRoute } from '../matchLocaleFromRoute';
import { scriptChecker } from '../utility';

const Scripts = ({
  hasClickToChat,
  locale,
  dynatraceID,
}) => {
  useEffect(() => {
    scriptChecker();
  }, []);
  return (
    <>
      <Ensighten version="^0.1.0" />
      <Dynatrace
        version="^3.0.0"
        appId={dynatraceID}
        environment="e3"
      />
      <Qualtrics
        version="^1.34.0"
        zoneId="ZN_dhZtUGWqHlUlqhT"
        sampleType="pageview"
        sampleRate={100}
      />
      {hasClickToChat && (
      <ClickToChat
        version="^1.3.1"
        async={true}
        locale={locale}
        market={locale.slice(-2)}
      />
      )}
    </>
  );
};

Scripts.propTypes = {
  hasClickToChat: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  dynatraceID: PropTypes.string,
};

export const ComponentUnderTest = Scripts;

const loadDataAsProps = ({
  store: { getState },
  ownProps: {
    location: { pathname } = {},
    params: { locale: routeLocale = pathname && matchLocaleFromRoute(pathname) } = {},
  },
}) => {
  let locale = getState().getIn(['intl', 'activeLocale']);
  if (!global.BROWSER && typeof routeLocale === 'string') {
    locale = routeLocale;
  }
  return {
    locale: () => ({
      status: 'complete',
      data: locale.replace(
        /-([a-z]{2})/i,
        (match, group) => `-${group.toUpperCase()}`
      ),
    }),
  };
};
loadDataAsProps.ssr = true;

export default compose(
  withRouter,
  connectAsync({ loadDataAsProps })
)(Scripts);
